export default __webpack_public_path__ + "static/media/section-mini.afa0dd8f.mp4";